import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'cleanAddress'
})
export class CleanAddressPipe implements PipeTransform
{
  private directMessageStatusClass = 'badge badge-secondary ml-2';
  private listDirectMessageStatuses: Array<{ text: string; value: string }> = [
    { text: 'Sent', value: 'SENT' },
    { text: 'Delivered', value: 'DELIVERED' },
    { text: 'Unknown', value: 'UNKNOWN' },
    { text: 'Failed', value: 'FAILED' }
  ];

  constructor(
    private sanitized: DomSanitizer,
    private translate: TranslateService)
  {
    this.translate.get('DIRECT-MESSAGE-STATUSES').subscribe({
      next: (res) =>
      {
        const splitted = res.split(',');
        for (let i = 0; i < splitted.length; i++)
        {
          if (this.listDirectMessageStatuses.length > i)
          {
            this.listDirectMessageStatuses[i].text = splitted[i];
          }
        }
      }
    });
  }

  public transform(value: any, index: number, directAddressStatus = '', separator = ','): any
  {
    let cleanAddress = '';
    if (index > 0)
    {
      cleanAddress += separator + ' ';
    }
    const addressStatus = this.getDirectMessageStatus(directAddressStatus);
    const formattedDirectAddressStatus = addressStatus !== '' ? ' ' + addressStatus : addressStatus;
    cleanAddress += `${value}${formattedDirectAddressStatus}`;
    return this.sanitized.bypassSecurityTrustHtml(cleanAddress);
  }

  private getDirectMessageStatus(directMessageStatus: string): string
  {
    let formattedStatus = '';
    const displayText = this.getDirectMessageStatusText(directMessageStatus);
    let color = '#dc5d3f';  // Failed and others errors are red
    switch (directMessageStatus)
    {
      case 'SENT':
      case 'DELIVERED':
      case 'UNKNOWN':
      case 'FAILED':
        // Set color to use for the badges
        if (directMessageStatus === 'SENT') { color = '#c4ced8'; }
        else if (directMessageStatus === 'DELIVERED') { color = '#7d9550'; }
        else if (directMessageStatus === 'UNKNOWN') { color = '#fb8c00'; }
        formattedStatus = `<span class="${this.directMessageStatusClass}" style="top:0;background-color:${color}">${displayText}</span>`;
        break;
    }
    return formattedStatus;
  }

  /**
   * Provide the translated direct message status text.
   *
   * @param messageStatus Direct message status.
   */
  private getDirectMessageStatusText(messageStatus: string): string
  {
    const status = this.listDirectMessageStatuses.find(x => x.value === messageStatus);
    return status && status.text ? status.text : messageStatus;
  }
}
